<script lang="ts">
  import { onMount } from "svelte";
  import { roleStore } from "../stores/roleStore";

  import HomeClient from "../components/Home/HomeClient.svelte";
  import HomeExpert from "../components/Home/HomeExpert.svelte";
  import { setRole } from "../utils/setRole";
  import { translation } from "../stores";
  import HomeHeader from "../components/Home/HomeHeader.svelte";

  export let params: Record<string, string> = {};

  onMount(() => {
    setRole();
  });
</script>

<div class="text-center p-1">
  {#if $roleStore === "expert"}
    <HomeHeader title={`${translation.appName} - Expert`} />
    <section class="card px-4 flex justify-center">
      <HomeExpert {params} />
    </section>
  {:else}
    <HomeHeader title={`${translation.appName}`} />
    <section class="card px-4 text-start">
      <HomeClient {params} />
    </section>
  {/if}
</div>
